import { Button, Form } from "react-bootstrap";
import { Modal, MuniSpinner2 } from "../../../components";
import { useActaDetalleStore } from "../../../store/actaDetalleStore";
import { useNotificadoresStore } from "../../../store/notificadoresStore";
import { useEffect, useState } from "react";
import useNotificadores from "../../../api/notificadores";
import { useGeneralAppStore } from "../../../store/generalAppStore";

const ModalReasignar = ({ modals, handlerModal, setRefetch }) => {

    //? ESTADOS GLOBALES
    const { acta } = useActaDetalleStore()
    const { notificadores } = useNotificadoresStore();
    const { loads } = useGeneralAppStore();

    //TODO API
    const { getNotificadores } = useNotificadores();
    const { reasignarNotificador } = useNotificadores();

    //* ESTADOS LOCALES
    const [notificadorSelect, setNotificadorSelect] = useState();
    const [nombreNotificador, setNombreNotificador] = useState();

    useEffect(() => {
        if (!notificadores) {
            getNotificadores();
        }
    }, []);

    useEffect(() => {
        if (notificadorSelect) {
            const notificador = notificadores.find((notificador) => notificador.usuarioID == notificadorSelect);
            if (notificador) {
                setNombreNotificador(notificador.nombre);
            }
        }
        if (notificadorSelect == "") {
            setNombreNotificador(null);
        }
    }, [notificadorSelect])

    const reasignar = (usuarioID) => {
        reasignarNotificador({ actas: [acta.id], user_id_asignado: usuarioID },setRefetch);
    }


    return (
        <>
            <Modal
                show={modals.includes('reasignar_notificador')}
                size={"lg"}
                onHide={() => handlerModal({ modal: false, modalName: "reasignar_notificador" })}
                title={() => "Reasignar notificador"}
            >
                <div className="d-flex flex-column gap-2 pt-2 pb-4 position-relative ">
                    {
                        loads.includes('reasignar_notificador') &&
                        <div className="d-flex justify-content-center align-items-center position-absolute w-100 h-100" style={{ backgroundColor: "rgba(255,255,255,0.7)" }}>
                            <MuniSpinner2 />
                        </div>
                    }
                    <div className="d-flex flex-column gap-2 align-items-start">
                        <div className="d-flex gap-3">
                            <h4 className="m-0">Notificador reciente</h4>
                            <h4 className="m-0">-</h4>
                            <h4 className="fw-medium text-dark m-0">{acta.notificadores[0]?.persona?.nombre}</h4>
                        </div>
                        <Button
                            onClick={() => { reasignar(acta.notificadores[0].persona.usuarioID) }}
                        >Asignar mismo notificador</Button>
                    </div>
                    <hr />
                    <Form.Group className="d-flex flex-column gap-4 align-items-start">
                        <div>
                            <h4 className="m-0">Asignar nuevo notificador</h4>
                            <Form.Select
                                style={{ width: "fit-content" }}
                                onChange={(e) => { setNotificadorSelect(e.target.value) }}
                            >
                                <option value={''}>Seleccione un nuevo notificador</option>
                                {notificadores?.map((notificador) => (
                                    <option key={notificador.usuarioID} value={notificador.usuarioID}>
                                        {notificador.nombre}
                                    </option>
                                ))}
                            </Form.Select>
                        </div>
                        <div className="d-flex gap-2 align-items-end">
                            <h5 className="m-0">Notificador seleccionado:</h5>
                            <h5 className={`${(!nombreNotificador || nombreNotificador == "") ? "text-danger " : "text-dark"} fw-medium m-0`}>{`${nombreNotificador ? nombreNotificador : "No tiene notificador seleccionado"}`}</h5>
                        </div>

                        <Button
                            onClick={() => { reasignar(Number(notificadorSelect)) }}
                            disabled={!nombreNotificador}>Asignar nuevo notificador</Button>
                    </Form.Group>
                </div>
            </Modal>
        </>
    );
}
export default ModalReasignar;